import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function WhyItFailed() {
  const reasons = ['Dejarlo llorar no funcionó porque te resultó imposible no intervenir.', 'Las rutinas rígidas no funcionaron porque no se adaptan a los cambios diarios de tu bebé.', 'Los consejos genéricos no funcionaron porque no consideraron tu nivel de cansancio y frustración.', 'Probar múltiples métodos a la vez solo aumentó la confusión y el agotamiento.', 'Ningún método te dio un plan claro para las primeras 48 horas.'];
  return <section className="py-20" data-id="element-350">
      <div className="max-w-4xl mx-auto px-6" data-id="element-351">
        <FadeIn data-id="element-352">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-12" data-id="element-353">
            Por qué lo que probaste{' '}
            <span className="text-brown italic" data-id="element-354">no funcionó</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-355">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-356">
              <div className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-cream-dark hover:shadow-md transition-shadow" data-id="element-357">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cream flex items-center justify-center mt-1" data-id="element-358">
                  <X className="w-5 h-5 text-brown/60" data-id="element-359" />
                </div>
                <p className="text-lg text-brown-dark/80 pt-1" data-id="element-360">{reason}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}